import $ from 'jquery';
import Helpers from '../helpers/util';

const $el = $('.js-sidebar');
const $cta = $('.js-sidebar__cta');

class SidebarPanel {
	constructor($el) {
		this.$el = $el;
		this.$inner = $el.find('.sidebar__inner');
		this.$close = $el.find('.js-sidebar__close');
		this.$cta = $cta;

		this.clsActive = 'is-active';
		this.clsAnimating = 'is-animating';
		this.clsModalOpen = 'is-modal-open';

		// Make sure body has the correct class when Lightbox is visible
		if (this.$el.hasClass(this.clsActive)) {
			document.body.classList.add(this.clsModalOpen);
		}

		this.attachHandlers();
	}

	showHandler(evt) {
		let currentTarget = $(evt.currentTarget);
		let $target = currentTarget.attr('data-sidebar');
		let $sidebarItem = this.$el.find('.sidebar__content');

		if ($sidebarItem.hasClass(this.clsActive)) {
			$sidebarItem.removeClass(this.clsActive);
		}

		if ($target) {
			// Prevent scroll page
			document.body.style.top =
				0 - parseInt(window.pageYOffset, 10) + 'px';
			document.body.classList.add(this.clsModalOpen);

			// Attributes accessibility
			this.$el.get(0).setAttribute('tabindex', '0');
			this.$el.get(0).setAttribute('aria-hidden', 'false');
			this.$el.get(0).focus();

			this.$el.addClass(this.clsActive);
			this.$el.addClass(this.clsAnimating);
			this.$el.find('.js-sidebar-' + $target).addClass(this.clsActive);

			this.activeSidebar = this.$el.find('.js-sidebar-' + $target);
			Helpers.pubsub.publish('onSidebarShow', currentTarget);
		}
	}

	closeHandler() {
		this.$el.removeClass(this.clsActive);
		this.$el.addClass(this.clsAnimating);

		this.$el.one(
			'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
			() => {
				// Attributes accessibility
				this.$el.get(0).setAttribute('tabindex', '-1');
				this.$el.get(0).setAttribute('aria-hidden', 'true');

				// Restore scroll page
				this.restoreScroll();

				// Event Emitter
				Helpers.pubsub.publish('onSidebarClose', this.activeSidebar);
			}
		);
	}

	restoreScroll() {
		// Restore scroll page
		document.body.classList.remove(this.clsModalOpen);
		const scrollTop = parseInt(
			document.body.style.top.replace(/[^\d]+/g, ''),
			10
		);
		window.scrollTo(0, scrollTop);
	}

	attachHandlers() {
		// Open
		this.$cta.on('click', evt => {
			evt.preventDefault();
			this.showHandler(evt);
		});

		// Close clicking out of it
		this.$el.on('click', evt => {
			evt.preventDefault();
			this.closeHandler();
		});

		// Close by button X
		this.$close.on('click', evt => {
			evt.preventDefault();
			this.closeHandler();
		});

		// Close by pressing ESC
		$(document).keyup(e => {
			if (e.key === 'Escape') {
				this.closeHandler();
			}
		});

		// Stop props on children
		this.$inner.on('click', evt => {
			evt.stopPropagation();
		});

		// On Animation finish, remove the 'is-animating' class.
		// This close moves the animation in frame for entire duration
		Helpers.dom.onTransitionEndAlways(this.$el, () => {
			this.$el.removeClass(this.clsAnimating);
		});

		// Close Listener
		Helpers.pubsub.subscribe('closeSidebar', () => {
			this.closeHandler();
		});

		// SPVPP-176
		// This 'fix' stopped our scroll carousel from working properyly. It has been removed
		// It meant that when your cursor was over the carousel, the page would no longer scroll
		// --------------------------------------------------------------------------------------
		// Force scrolling >> blocked due to Dragdrop
		// $('.js-scrollfix').on('mousewheel ', function(e) {
		// 	e = e.originalEvent;
		// 	let delta = e.wheelDelta > 0 || e.detail < 0 ? 1 : -1;
		// 	this.scrollTop -= delta * 30;
		// 	e.preventDefault();
		// });
	}
}

const _init = () => {
	if ($el.length && $cta.length) {
		new SidebarPanel($el);
	}
};

_init();
